'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _MessageInfo = require('./MessageInfo');

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default,
        MessageInfo: _MessageInfo2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },
    computed: {
        userColour: function userColour() {
            return this.ml.userColour(this.message.user);
        }
    },
    methods: {
        getNetwork: function getNetwork() {
            return this.ml.buffer.getNetwork();
        },
        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        userMode: function userMode(user) {
            return this.ml.buffer.userMode(user);
        },
        userModePrefix: function userModePrefix(user) {
            return this.ml.buffer.userModePrefix(user);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageCompact"]
window._kiwi_exports.components.MessageListMessageCompact = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageListMessageCompact.vue
// module id = NRRm
// module chunks = 1